import { FC } from 'react'
import { Checkbox } from '@mui/material'
import { CheckBoxContainer } from './styled'

export const CheckBox: FC<ICheckBox> = ({ checked = false, label = '', handleChange }) => {
  return (
    <CheckBoxContainer onClick={() => handleChange(!checked)}>
      <Checkbox
        checked={checked}
        // onChange={}
        color='warning'
      />
      <p>{label}</p>
    </CheckBoxContainer>
  )
}

interface ICheckBox {
  label?: string
  checked?: boolean
  handleChange: (e: boolean) => void
}
